exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".hextech-radioInput-392Zm{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;outline:none}\n", ""]);

// Exports
exports.locals = {
	"radioInput": "hextech-radioInput-392Zm"
};